import React, {Component} from 'react';
import determineIfMobile from '@homeaway/react-determine-if-mobile';

/**
 * A determineIfMobile() that hydrates consistently
 */
export default (WrappedComponent) =>
    class HydratableDetermineIfMobile extends Component {
        constructor(props) {
            super(props);
            this.state = {isMounted: false};
        }

        componentDidMount() {
            // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({isMounted: true});
        }

        getMobileBreakpoint = () => {
            if (this.state.isMounted) {
                // The component has already been hydrated, let DetermineIfMobile take over
                // eslint-disable-next-line no-undefined
                return this.props.mobileBreakpoint;
            }

            // We are either rendering on the server side or for the first time
            // on the client side, so we must ensure we use the same isMobile to
            // avoid hydration mismatches. DetermineIfMobile is not being consistent
            // here so we must trick it to produce a consistent value.
            return this.props.isMobile ? Infinity : 0;
        }

        render() {
            const DetermineIfMobile = determineIfMobile(WrappedComponent);
            return (
                <DetermineIfMobile
                    {...this.props}
                    mobileBreakpoint={this.getMobileBreakpoint()}
                />
            );
        }
    };

